import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { DropDownMenuItem } from './DropDownMenuItem.js';
export const FilterOptionSelector = (props) => {
    const lang = useSelector((s) => s.lang);
    const groups = props.filterOptions.reduce((acc, option) => {
        const group = option.displayGroup ? option.displayGroup(lang) : '';
        if (!acc[group]) {
            acc[group] = [];
        }
        acc[group].push(option);
        return acc;
    }, {});
    return (React.createElement(React.Fragment, null, Object.entries(groups).map(([group, options]) => (React.createElement("div", { key: group },
        React.createElement(FilterGroupHeader, null,
            React.createElement("span", null, group)),
        options.map((option) => (React.createElement(DropDownMenuItem, { key: option.key, icon: option.icon, label: option.label(lang), onClick: () => props.onSelectToplevelOption(option) }))))))));
};
const FilterGroupHeader = styled.div `
  border-bottom: 1px solid ${THEME.BORDER_STRONG};
  line-height: 0.1em;
  margin: 8px -4px;

  & > span {
    background: #fff;
    padding: 0 4px;
    margin-left: 8px;
    font-size: 0.8em;
    color: ${THEME.TEXT_MUTED};
  }
`;
export const FilterConfiguration = (props) => {
    return React.createElement(props.filterOption.picker, {
        filter: props.filter,
        setFilter: props.onFilterUpdate,
        searchText: props.searchText,
        onCloseMenu: props.onCloseMenu,
    });
};
export const FilterTypeConfiguration = (props) => {
    return React.createElement(props.filterOption.typePicker, {
        filter: props.filter,
        setFilter: props.onFilterUpdate,
        onCloseMenu: props.onCloseMenu,
    });
};
//# sourceMappingURL=FilterConfiguration.js.map